import React, { useEffect } from 'react';
import AppHeader from '../AppHeader';
import SelectDropdown from '../SelectDropdown';
import { CircularProgress, Box } from '@mui/material';
import {
  getDropdownOptions,
  getTrendDropdownOptions,
  toTitleCase,
  getStoreChecker,
  getLocationNameWithoutState,
  getLocationStateToken,
  resolveOmniServicesDropdownValue,
} from '../../utils/utils';
import { useLazyQuery } from '@apollo/client';
import { GET_DEFAULT_LOCATION } from '../../graphql/queries';
import ErrorMessage from '../ErrorMessage';
import {
  DATA_FETCH_ERROR,
  ONLOAN_INVALID_STOREID_ERROR,
  TREND,
  OMNI_CHANNEL,
} from '../../common/constants';
import './styles.scss';
import BottomNavigator from '../BottomNavigator/BottomNavigator';
import { connect, useSelector } from 'react-redux';
import { setCurrentDateMatrix } from '../../actions/actions';
import { OmniTabManager } from '../TabManager';
import PropTypes from 'prop-types';

const filterContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'flex-start',
  mt: 1,
};

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    fontSize: '1.6rem',
    fontFamily: 'Franklin Gothic Pro ',
    color: state.isSelected ? '#FFFFFF' : '#353535',
    padding: 7,
  }),
};

const OmniChannelDetails = ({ employeeInfo = {}, currentDateMatrix }) => {
  const [options, setOptions] = React.useState([]);
  const [activeTab, setActiveTab] = React.useState('');
  const currentActiveTab = useSelector(
    (state) => state.currentActiveTab.currentActiveTab
  );
  useEffect(() => {
    setActiveTab(currentActiveTab);
  }, [activeTab, currentActiveTab]);

  const [selectedDate, setSelectedDate] = React.useState(null);
  const userEmail = employeeInfo.adUpn;
  const [selectedLocation, setSelectedLocation] = React.useState(
    JSON.parse(sessionStorage.getItem('selectedLocation'))
  );
  let selectedStoreId = localStorage.getItem('storeId');
  const activeStorechecker = getStoreChecker(selectedStoreId);
  const [
    getDefaultLocation,
    { error: locationError = {}, loading: locationLoading },
  ] = useLazyQuery(GET_DEFAULT_LOCATION, {
    onCompleted: (data) => {
      let { salesSummaryV2 } = data;
      if (selectedLocation.locationName === 'NA') {
        setSelectedLocation({
          locationNo: salesSummaryV2?.location?.primaryLocationNumber,
          locationName: salesSummaryV2?.location?.primaryLocationName,
        });
        sessionStorage.setItem(
          'selectedLocation',
          JSON.stringify({
            locationNo: salesSummaryV2?.location?.primaryLocationNumber,
            locationName: salesSummaryV2?.location?.primaryLocationName,
          })
        );
      }
    },
  });

  useEffect(() => {
    let options =
      activeTab === TREND ? getTrendDropdownOptions() : getDropdownOptions();
    setOptions(options);

    const selectedDate = localStorage.getItem('selectedDate');
    const dropdownVal = resolveOmniServicesDropdownValue(activeTab, selectedDate);

    const defaultValue = options.find((obj) => obj.value === dropdownVal);
    setSelectedDate(defaultValue);
    currentDateMatrix(defaultValue);
  }, [setOptions, setSelectedDate, activeTab, currentDateMatrix]);

  useEffect(() => {
    if (userEmail && (activeStorechecker === true || selectedStoreId === '')) {
      getDefaultLocation({
        variables: { request: { email: userEmail, storeId: selectedStoreId } },
        context: {
          headers: {
            Authorization: localStorage.getItem('jwtToken'),
          },
        },
      });
    }
  }, [userEmail, getDefaultLocation, selectedStoreId, activeStorechecker]);

  const handleDateChange = (e) => {
    setSelectedDate(e);
    currentDateMatrix(e);
    localStorage.setItem('selectedDate', e.value);
  };

  const primarylocation = selectedLocation?.locationName;
  const statelocation = getLocationStateToken(primarylocation);
  const withoutstatelocation = getLocationNameWithoutState(primarylocation);

  return (
    <AppHeader
        headerContent={
          <Box sx={filterContainerStyles}>
            {locationLoading ? (
              <CircularProgress color="inherit" size={30} />
            ) : (
              <div className="locationRow">
                {toTitleCase(withoutstatelocation ?? withoutstatelocation)}
                {primarylocation === 'NA' || statelocation.length !== 2 ? (
                  ''
                ) : (
                  <span>, {statelocation}</span>
                )}
              </div>
            )}
            {options.length > 0 ? (
              <div className="blue-dropdown">
                <SelectDropdown
                  className="dateRow"
                  styles={customStyles}
                  onChange={handleDateChange}
                  options={options}
                  value={selectedDate}
                  isSearchable={false}
                />
              </div>
            ) : (
              <CircularProgress color="inherit" size={30} />
            )}
          </Box>
        }
      >
        {locationError.message ? (
          <ErrorMessage
            statusCode={locationError?.networkError?.statusCode}
            message={DATA_FETCH_ERROR}
          />
        ) : null}
        {activeStorechecker === false && selectedStoreId ? (
          <ErrorMessage message={ONLOAN_INVALID_STOREID_ERROR} />
        ) : null}
        <OmniTabManager />
        <BottomNavigator
          Label={OMNI_CHANNEL}
          LeftRoute="/services-details/drivers"
          RightRoute="/labor-details/labor"
          DisableRight={false}
          DisableLeft={false}
        />
      </AppHeader>
  );
};

OmniChannelDetails.propTypes = {
  employeeInfo: PropTypes.shape({ adUpn: PropTypes.string }),
  currentDateMatrix: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  employeeInfo: state.auth.employeeInfo,
});
const mapDispatchToProps = (dispatch) => ({
  currentDateMatrix: (selectedDateMatrix) =>
    dispatch(setCurrentDateMatrix(selectedDateMatrix)),
});
export default connect(mapStateToProps, mapDispatchToProps)(OmniChannelDetails);
